import Controller from './Controller';
import { Combined_CreateDefaultFSM } from '../commands/combined';
import type { AnyCheck } from '../commands/types';

/**
 * Controller to upgrade a model to the latest version of the data model after
 * loading it from the server. The main purpose of this controller is to make
 * sure we can safely load models created with older versions of the tool after
 * features have been added.
 */
export default class UpgradeModelController extends Controller {
  /**
   * Check if there are object types without a default FSM and add it if
   * necessary.
   */
  async addDefaultFSMs(): Promise<void> {
    if (this.modelVersion.content!.metamodel.objectTypes.some((o) => o.defaultFSM == null)) {
      this.executeAndCheck((model) => {
        const checks: AnyCheck[] = [];
        for (const ot of model.metamodel.objectTypes) {
          if (ot.defaultFSM == null) {
            const { checks: extraChecks } = Combined_CreateDefaultFSM(model, ot);
            checks.push(...extraChecks);
          }
        }
        return checks;
      });
    }
  }

  async upgradeModel(): Promise<void> {
    await this.addDefaultFSMs();
  }
}
